import {header} from './header';
import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {discountCategorySponsorship_template} from '../components/templates/discountCategorySponsorship_template';
import {vn_app_zone_notification} from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';

declare var ko: any;
declare var page: any;

export class discount_category_sponsorship extends vnModule_knockoutJS {

    protected form: discountCategorySponsorship_template;
    protected saveRequest: XMLHttpRequestHandler;

    protected getModuleName(): string {
        return 'discount_category_sponsorship';
    }

    buildContent(): Element[] {
        this.form = new discountCategorySponsorship_template('discountCategorySponsorship', this.viewModel, this);

        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        (zoneHeader.loadedModule as header).setHeaderTitle('Discount Categories');

        return [this.form.build()];
    }

    fillPage(): void {
        const request = new XMLHttpRequestHandler('/api/discounts/categories/get/', [], this);
        request.onReadyStateFunction = (req, obj) => () => obj.manageResponse(req, obj, () => {
            obj.form.setCategories(JSON.parse(req.request.response));

            const categoryId = Number(obj.getVnAppZone().app.params.categoryId);
            if (categoryId) {
                obj.form.setCategoryId(categoryId);
                obj.loadCategory(categoryId);
            }
        });
        request.execute();
    }

    public editCategory(id: number): void {
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/discounts/categories/edit/' + id + '/');
    }

    public showCategories(): void {
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/discounts/categories/');
    }

    public loadCategory(id: number): void {
        if (!id) {
            this.form.clearCategory();
            return;
        }

        const request = new XMLHttpRequestHandler('/api/discounts/categories/configuration/' + id + '/', [], this);
        request.onReadyStateFunction = (req, obj) => () => obj.manageResponse(req, obj, () => {
            obj.form.setCategoryConfiguration(JSON.parse(req.request.response));
        });
        request.execute();
    }

    public getSuggestions(keyword: string, idSourceElement: string): void {
        if (idSourceElement !== 'filter_categoryDiscounts') {
            return;
        }

        const matchingDiscounts = this.form.getTemplateViewModel().availableDiscounts()
            .filter(discount => discount.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1)
            .map(discount => ({
                id: discount.id,
                name: discount.name,
                slug: discount.slug,
                displayNameComplement: discount.name + (discount.merchant && discount.merchant.name ? ' (' + discount.merchant.name + ')' : ''),
                isSelectable: 1
            }));

        this.form.setDiscountSuggestions(matchingDiscounts);
    }

    public onAutocompleteOptionChange(idElement: string): void {}
    public onAutocompleteInputClear(idElement: string): void {}
    public onAutocompleteInputClick(idElement: string): void {}

    public save(): void {
        const viewModel = this.form.getViewModelForRequest();
        if (!viewModel.id) {
            return;
        }
        if ((viewModel.idSponsorImage && !viewModel.sponsorUrl) || (!viewModel.idSponsorImage && viewModel.sponsorUrl)) {
            this.form.setSaveStatus('A sponsor logo and URL must be set together.');
            this.notify('A sponsor logo and URL must be set together.');
            return;
        }
        if (viewModel.sponsorUrl && !viewModel.sponsorUrl.toLowerCase().startsWith('https://')) {
            this.form.setSaveStatus('Sponsor URL must use HTTPS.');
            this.notify('Sponsor URL must use HTTPS.');
            return;
        }

        if (this.saveRequest) {
            this.saveRequest.cancelAndReset();
        }

        this.form.setSaveStatus('Saving category configuration...');
        this.saveRequest = new XMLHttpRequestHandler(
            '/api/discounts/categories/configuration/' + viewModel.id + '/',
            [['data', ko.toJSON(viewModel)]],
            this
        );
        this.saveRequest.mode = XMLHttpRequestHandler_requestType.POST;
        this.saveRequest.onReadyStateFunction = (req, obj) => () => {
            if (req.request.readyState !== 4) {
                return;
            }

            if (req.request.status !== 200) {
                if (req.request.status === 401 || req.request.status === 423) {
                    obj.manageResponse(req, obj, null);
                    return;
                }

                try {
                    const response = JSON.parse(req.request.response);
                    obj.form.setSaveStatus(response.error || response.message || 'Could not save the category configuration.');
                } catch (error) {
                    obj.form.setSaveStatus('Could not save the category configuration.');
                }
                return;
            }

            obj.manageResponse(req, obj, () => {
                obj.form.setSaveStatus('Category configuration saved successfully.');
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    'Discount category configuration saved successfully.'
                );
                obj.getVnAppZone().showNotificationToModule();
                obj.loadCategory(viewModel.id);
            });
        };
        this.saveRequest.execute();
    }

    public notify(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    protected insertImage(image, target, extra) {
        if (target === 'sponsor_image') {
            this.form.setSponsorImage(image);
        }
    }

    public removeImage(target) {
        if (target === 'sponsor_image') {
            this.form.removeSponsorImage();
        }
    }

    public setIsImageOptimized(value) {}
}



// WEBPACK FOOTER //
// ./js/modules/discount_category_sponsorship.ts